module.exports = __webpack_public_path__ + "static/media/customer-heritage.c7892c50.png";